import { wymsFetch, getAxiosService } from '@/utils/fetch'

export const execFetch = getAxiosService({
    timeout: 100000,
    isProcessResponse: true,
    baseURL: global.command === 'production' ? 'https://wyms.weixiaojia.cn/wyms' : 'https://wyms.weixiaojia.net/wyms'
});
export function sqlToolTemplateCreate(args) {
    let params = new URLSearchParams();
    params.append('moduleName', args.moduleName);
    params.append('tempContext', args.tempContext);
    params.append('tempName', args.tempName);
    params.append('tempType', args.tempType);

    return wymsFetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'sqlTool/template/create',
        method: 'POST',
        data: JSON.stringify(args)
    });
}
export function sqlToolTemplateList(args) {
    let params = new URLSearchParams();
    params.append('sqlName', args.sqlName);

    return wymsFetch({
        url: 'sqlTool/template/list',
        method: 'GET',
        params
    });
}
export function sqlToolTemplateQuery(args) {
    let params = new URLSearchParams();
    params.append('sqlTemplateId', args.sqlTemplateId);

    return wymsFetch({
        url: 'sqlTool/template/query',
        method: 'GET',
        params
    });
}
export function sqlToolTemplateDelete(args) {
    let params = new URLSearchParams();
    params.append('sqlTemplateId', args.sqlTemplateId);

    return wymsFetch({
        url: 'sqlTool/template/delete',
        method: 'POST',
        data: params
    });
}
export function sqlTemplateExecute(args) {
    let params = new URLSearchParams();

    return execFetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'sqlTool/execute/sqlTemplate',
        method: 'POST',
        data: JSON.stringify(args)
    });
}

export function sqlToolTemplateHistory(args) {
    let params = new URLSearchParams();
    params.append('sqlName', args.sqlName);

    return wymsFetch({
        url: 'sqlTool/execute/history',
        method: 'GET',
        params
    });
}
export function sqlTemplateAgain(args) {
    let params = new URLSearchParams();
    params.append('historyId', args.historyId);
    return execFetch({
        url: 'sqlTool/execute/again',
        method: 'POST',
        data: params
    });
}



// WEBPACK FOOTER //
// ./src/api/sql.js